/* unplugin-vue-components disabled */import script from "./SubjectTab.vue?vue&type=script&setup=true&lang=js"
export * from "./SubjectTab.vue?vue&type=script&setup=true&lang=js"

import "./SubjectTab.vue?vue&type=style&index=0&id=1b4593ca&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1b4593ca"]])

export default __exports__